import { createFileRoute } from "@tanstack/react-router";
import { Result, Typography } from "antd";
import { useConfirmTenantDeletionMutation } from "api/Tenant/hooks.ts";
import { AuthLayout } from "components/Layouts/AuthLayout/AuthLayout.tsx";
import { AuthButton } from "components/UI/AuthButton/AuthButton.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useState } from "react";

export const Route = createFileRoute("/$tenantSlug/confirm-deletion/")({
    component: ConfirmTenantDeletionPage,
    validateSearch: (search: Record<string, unknown>) => ({
        expires: search.expires != null ? String(search.expires) : null,
        hash: typeof search.hash === "string" ? search.hash : "",
        slug_name: typeof search.slug_name === "string" ? search.slug_name : "",
        signature: typeof search.signature === "string" ? search.signature : null,
    }),
});

function ConfirmTenantDeletionPage() {
    const search = Route.useSearch();
    const { t } = usePaldockTranslation("pages.confirm-tenant-deletion");
    const [confirmed, setConfirmed] = useState(false);
    const [error, setError] = useState(false);

    const confirmMutation = useConfirmTenantDeletionMutation({
        onSuccess: () => setConfirmed(true),
        onError: () => setError(true),
    });

    const isValidLink = !!(search.slug_name && search.signature);

    return (
        <AuthLayout>
            <AuthPageContainer>
                {confirmed ? (
                    <Result status="success" title={t("success_title")} subTitle={t("success_message")} />
                ) : error || !isValidLink ? (
                    <Result status="error" title={t("error_title")} subTitle={t("error_message")} />
                ) : (
                    <Result
                        status="warning"
                        title={t("title")}
                        subTitle={<Typography.Text>{t("confirm_message")}</Typography.Text>}
                        extra={[
                            <AuthButton
                                key="confirm"
                                danger
                                loading={confirmMutation.isPending}
                                onClick={() => confirmMutation.mutate(search)}
                            >
                                {t("actions.confirm")}
                            </AuthButton>,
                        ]}
                    />
                )}
            </AuthPageContainer>
        </AuthLayout>
    );
}
